import { BalanceSide } from '../enums/balanceSide'
import type { BalanceSideConfig } from './balanceSideConfig'
import { customerBalanceConfig } from './customerBalanceConfig'
import { supplierBalanceConfig } from './supplierBalanceConfig'

export type { BalanceSideConfig } from './balanceSideConfig'
export { supplierBalanceConfig } from './supplierBalanceConfig'

export const BALANCE_SIDE_CONFIG: Record<BalanceSide, BalanceSideConfig> = {
  [BalanceSide.Supplier]: supplierBalanceConfig,
  [BalanceSide.Customer]: customerBalanceConfig,
}
